import moment from 'moment'

const cardResultStatusMap = {
  1: '很好',
  2: '良好',
  3: '一般',
  4: '不好',
  5: '无回复'
}

// 疗效反馈/自述反馈共用的状态文案映射
export const flowFeedbackResultStatusMap = {
  0: '未填写',
  100: '用药中',
  2: '治愈',
  3: '失访',
  4: '无效',
  5: '有效'
}

export const formatEvaluateDate = value => {
  if (!value) return '--'
  const date = moment(value)
  return date.isValid() ? date.format('YYYY-MM-DD') : String(value)
}

const formatCardName = value => {
  if (!value) return '--'
  const cardName = String(value).match(/第.+?次/)
  return cardName?.[0] || String(value)
}

export const createTimelineItem = item => {
  const isFeedback = item.cardType === 2
  const status = isFeedback
    ? flowFeedbackResultStatusMap[item.resultStatus] || '--'
    : cardResultStatusMap[item.resultStatus] || '--'

  return {
    id: item.cardId,
    tag: item.cardTypeName,
    date: formatEvaluateDate(item.evaluateTime),
    round: formatCardName(item.cardName),
    status
  }
}
